import {tApi}from 'tplus-api';
import { localStore } from 'mutants-microfx';
import { platform } from 'mutants-util';
export default class MemberApi {

    //获取会员改变信息
    static async getMemberChangedData(dto){
        const {IDMemberType, RetailDetails} = dto;
        const details = [];
        for(var detail of RetailDetails)
        {
            const cloneDetail = {};
            cloneDetail.Idinventory = detail.Idinventory;
            cloneDetail.Idunit = detail.Idunit;
            cloneDetail.UnitExchangeRate = detail.UnitExchangeRate;
            details.push(cloneDetail);
        }
        return await tApi({
            IDMemberType:IDMemberType,
            Details:details,
            IsSelfCash:platform.isVerticalTouch
        },'chanjet.AA.DR.INewRetailMember.GetMemberChangedData',false,false);
    } 
    
    //获取会员改变信息
    static async getMemberDiscountRateAndPriceData(IdMemberType, IdInventory, IdUnit){
        return await tApi({
            IdMemberType:IdMemberType,
            IdInventory:IdInventory,
            IdUnit:IdUnit
        },'chanjet.AA.DR.INewRetailMember.GetMemberDiscountRateAndPriceData',false,false);
    }   

    static getLoginInfo() {
        const { loginInfo = {} } = localStore.get('user') || {};
        return loginInfo;
    }

    static async getSearchMember(obj) {
        const { IdStore, StoreCode } = this.getLoginInfo();
        const SearchParams = {
          CurrentPage: obj.currentPage,
          PageSize: obj.pageSize,
          Key: obj.key,
          IsSingleMember: obj.isSingleMember,
          IdStore,
          StoreCode
        };
        const data = await tApi({
          SearchParams
        }, 'chanjet.AA.DR.INewRetailMember.SearchMember', false, false);
        return data;
      }

}
